import React from 'react';
import { useSelector } from 'react-redux';
import { selectAppTheme } from 'src/redux/profile-preferences/selectors';

export const useResolvedTheme = (): 'dark' | 'light' => {
  const theme = useSelector(selectAppTheme);

  const resolvedTheme = React.useMemo<'dark' | 'light'>(() => {
    if (theme !== 'system') return theme as 'dark' | 'light';
    const prefersDark = window.matchMedia?.('(prefers-color-scheme: dark)') || false;
    return prefersDark ? 'dark' : 'light';
  }, [theme]);

  return resolvedTheme;
};
